import { forwardRef } from "react"

import Select from "./Select"

const OPTIONS = [
  { label: "Yes", value: true, format: "Boolean" },
  { label: "No", value: false, format: "Boolean" },
]

const BooleanSelect = forwardRef((props, ref) => {
  const { value, onChange, ...rest } = props

  const selectedOption =
    OPTIONS.find((option) => option.value === value?.value) || null

  function handleChange(selected) {
    if (selected === null) {
      onChange(null)
    } else {
      onChange({ value: selected.value, kind: "Boolean", format: "Boolean" })
    }
  }

  return (
    <Select
      ref={ref}
      {...rest}
      value={selectedOption}
      options={OPTIONS}
      onChange={handleChange}
    />
  )
})

export default BooleanSelect
